import React, { createContext, useContext, useState, useRef } from "react";
import useApiHandler from "../hooks/ApiHandler";
import { User } from "../../service";
import { useEffect } from "react";
// Create Context
const StatisticsDataContext = createContext();

// Provider component
export function StatisticsDataProvider({ children }) {
  const [statisticsData, setStatisticsData] = useState(null);
  const { callApi, loading } = useApiHandler();
  const refreshTimeoutRef = useRef(null);

  const fetchStatistics = (opts = {}) => {
    callApi(() => User.getStatistics(), {
      ...opts,
      onSuccess: (response) => {
        setStatisticsData(response.data);
      },
    });
  };

  const refreshStatistics = () => {
    // Fast update for UI + a single follow-up fetch to handle eventual consistency.
    fetchStatistics();

    if (refreshTimeoutRef.current) {
      clearTimeout(refreshTimeoutRef.current);
    }
    refreshTimeoutRef.current = setTimeout(() => {
      fetchStatistics();
      refreshTimeoutRef.current = null;
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (refreshTimeoutRef.current) {
        clearTimeout(refreshTimeoutRef.current);
      }
    };
  }, []);

  // useEffect(() => {
  //   fetchStatistics();
  // }, []);

  return (
    <StatisticsDataContext.Provider
      value={{
        statisticsData,
        setStatisticsData,
        loading,
        fetchStatistics: fetchStatistics,
        refreshStatistics: refreshStatistics,
      }}
    >
      {children}
    </StatisticsDataContext.Provider>
  );
}

// Custom hook to use context
export function useStatisticsData() {
  const context = useContext(StatisticsDataContext);
  if (!context) {
    throw new Error(
      "useStatisticsData must be used within a StatisticsDataProvider"
    );
  }
  return context;
}
